export const expenseConstants = {
  CLOSE_ADD_EXPENSE_MODAL: 'CLOSE_ADD_EXPENSE_MODAL',
  OPEN_ADD_EXPENSE_MODAL: 'OPEN_ADD_EXPENSE_MODAL',
  GET_EXPENSE: 'GET_EXPENSE',
  CLEAR_EXPENSE_DATA: 'CLEAR_EXPENSE_DATA',
  OPEN_DUPLICATES_MODAL: 'OPEN_DUPLICATES_MODAL',
  CLOSE_DUPLICATES_MODAL: 'CLOSE_DUPLICATES_MODAL',
};
